import { Pipe, PipeTransform } from '@angular/core';
import { BuildingHouseCareContactDto } from '@artemis-software/wr-api';
import TypeEnum = BuildingHouseCareContactDto.TypeEnum;

export const houseCareContactTypeTranslations: Record<TypeEnum, string> = {
  CLEANING: 'Reinigung',
  GREEN_AREA_MAINTENANCE: 'Grünpflege',
  WINTER_SERVICE: 'Winterdienst',
};

@Pipe({
  standalone: false,
  name: 'houseCareContactTypeTranslation',
})
export class HouseCareContactTypeTranslationPipe implements PipeTransform {
  transform(value?: TypeEnum): string | undefined {
    return value ? houseCareContactTypeTranslations[value] : undefined;
  }
}
